import { ListSelect } from '@bambi/component-library/src/components/ListSelect/ListSelect';
import { TruckIcon, UserIcon } from '@heroicons/react/24/outline';

export type NextStepOption = 'driver-attendant' | 'attendant-only';

interface ProfileListSelectProps {
  value: NextStepOption;
  onChange: (value: NextStepOption) => void;
}

export function ProfileListSelect({ value, onChange }: ProfileListSelectProps) {
  return (
    <ListSelect
      value={value}
      items={[
        {
          title: 'Driver + Attendant',
          description:
            'Can be assigned to drive vehicles and attend to passengers.',
          value: 'driver-attendant',
          icon: <TruckIcon className="h-8 w-8 stroke-mint" />,
        },
        {
          title: 'Attendant only',
          description:
            'Can be assigned to attend to passengers but not drive.',
          value: 'attendant-only',
          icon: <UserIcon className="h-8 w-8 stroke-mint" />,
        },
      ]}
      onChange={onChange}
    />
  );
}
